export enum ButtonEvents {
    ADD = "ADD",
    COPY = "COPY",
    COPY_FORM = "COPY_FORM",
    DELETE = "DELETE",
    EXPORT = "EXPORT",
    IMPORT = "IMPORT",
    GO_BACK = "GO_BACK",
    SUBMITTED = "SUBMITTED",
    CANCELLED = "CANCELLED",
}
